import videojs from "video.js";

const Component = videojs.getComponent("Component");
const Button = videojs.getComponent("Button");

/**
 * The base class for buttons
 *
 * @param {Player|Object} player
 * @param {Object=} options
 * @extends Button
 * @class BlueFrameClippingButton
 */
class BlueFrameClippingButton extends Button
{
	/**
	 * Creates an instance of this class.
	 *
	 * @param {Player} player
	 *		The `Player` that this class should be attached to.
	 *
	 * @param {Object} [options={}]
	 *		The key/value store of player options.
	 */
	constructor(player, options = {})
	{
		super(player, options);
		this.player = player;
		this.overlay = player.getChild("BlueFrameClippingUI");
	}

	/**
	 * Builds the default DOM `className`.
	 *
	 * @return {string}
	 *		The DOM `className` for this object.
	 */
	buildCSSClass()
	{
		return `vjs-blueframe-clipping-button ${super.buildCSSClass()}`;
	}

	/**
	 * This gets called when an `BlueFrameClippingButton` is "clicked". See
	 * {@link ClickableComponent} for more detailed information on what a click can be.
	 *
	 * @listens tap
	 * @listens click
	 */
	handleClick()
	{
		if (this.overlay.showing())
		{
			this.overlay.hide();
		}
		else
		{
			this.overlay.show();
		}
	}
}

/**
 * The text that should display over the `BlueFrameClippingButton`s controls. Added for localization.
 *
 * @type {string}
 * @private
 */
BlueFrameClippingButton.prototype.controlText_ = "Create Clip";

Component.registerComponent("blueframeClippingButton", BlueFrameClippingButton);

export default BlueFrameClippingButton;
